function storeTrial(response, rowNo){
    /*left to add,
    ITI_ms
    ITI_f
    ITI_fDuration
    ISI_ms
    ISI_f
    ISI_fDuration
    presTime_ms
    presTime_f
    presTime_fDuration
    lastTimestamp?
    */


    const experimentId = getExperimentId();
    const trialKey = experimentId + '-' + rowNo;

    var currentTrialData = {};

    const headerColumns = JSON.parse(localStorage.getItem(experimentId+'-'+'header'));
    for(var index in headerColumns){
        currentTrialData[headerColumns[index]] = "";
    }

    for (var iCol = 0; iCol < allColumns.length; iCol++) {
        if (definedColumns[iCol] == 1) {
            const columnName = saveArrays[iCol][0];
            currentTrialData[columnName] = saveArrays[iCol][saveArrays[iCol].length-1];
        }
    }

    currentTrialData["rowNo"] = rowNo;
    currentTrialData["response"] = response.response;
    currentTrialData["responseCode"] = response.responseCode;
    currentTrialData["RT"] = response.RT;
    currentTrialData["timestamp"] = parseInt(response.timestamp);
    currentTrialData["correct"] = response.correct | 0;

    var orderedTrialData = [];

    for(var index in headerColumns){
        orderedTrialData.push(currentTrialData[headerColumns[index]]);
    }

    const currentStoredData = JSON.stringify(orderedTrialData);
    localStorage.setItem(trialKey, currentStoredData);

    //console.log('stored response data', currentStoredData, trialKey);

    //mark which trials were stored
    var trialsStored = JSON.parse(localStorage.getItem(experimentId+'-'+'trials')) || [];
    trialsStored.push(rowNo);
    localStorage.setItem(experimentId+'-'+'trials', JSON.stringify(trialsStored));
}

function initStorage(){
    const experimentId = getExperimentId();

    const resultHeader = [
        "rowNo",
        ...csvValidColumns,
        "timestamp",
        "response",
        "responseCode",
        "RT",
        "correct"
    ];
    localStorage.setItem(experimentId+'-'+'header', JSON.stringify(resultHeader));

    const resultInfoHeader = saveInfoColumns;
    const resultInfo = saveInfo;
    localStorage.setItem(experimentId+'-'+'info', JSON.stringify(resultInfo));
    localStorage.setItem(experimentId+"-"+'info-header', JSON.stringify(resultInfoHeader));
}

function getExperimentId(){
    const linkParts = location.href.split('/');
    const experimentId = linkParts[linkParts.length-2];
    return experimentId;
}

function restoreStoredData(){
    const experimentId = getExperimentId();

    const resultInfo = JSON.parse(localStorage.getItem(experimentId+'-'+'info'));
    const resultInfoHeader = JSON.parse(localStorage.getItem(experimentId+'-'+'info-header'))
    const resultHeader = JSON.parse(localStorage.getItem(experimentId+'-'+'header'));
    const trialsStored = JSON.parse(localStorage.getItem(experimentId+'-'+'trials')) || [];
    let trialData = [resultHeader];
    for(var index in trialsStored){
        const currentTrialData = JSON.parse(localStorage.getItem(experimentId+'-'+trialsStored[index]));
        trialData.push(currentTrialData)
        // resultContents += currentTrialData + '\n';
    }

    // if(!trialsStored.length){
    //     resultContents = null;
    // }

    let transposedData = transpose(trialData);

    trialData = removeNA(transposedData);
    transposedData = transpose(trialData);

    const preppedContents = convertServerContentToCsv(resultInfoHeader, resultInfo, transposedData);

    return preppedContents;
}

function clearStoredData(){
    const experimentId = getExperimentId();

    localStorage.removeItem(experimentId+'-'+'info');
    localStorage.removeItem(experimentId+'-'+'header');

    const trialsStored = JSON.parse(localStorage.getItem(experimentId+'-'+'trials')) || [];
    for(var index in trialsStored){
        localStorage.removeItem(experimentId+'-'+trialsStored[index]);
    }

    localStorage.removeItem(experimentId+'-'+'trials');
}

function downloadStoredData(){
    var isIE = false;
    if(navigator.userAgent.indexOf('MSIE')!==-1
    || navigator.userAgent.indexOf('Edge')!==-1
    || navigator.appVersion.indexOf('Trident/') > 0)
    {
        isIE = true;
    }

    var csvContentLocal =  restoreStoredData();
    if(csvContentLocal){
        var d = new Date();
        var timeSaved = d.getUTCFullYear().toString().slice(-2)+("0"+(d.getUTCMonth()+1)).slice(-2)+("0"+d.getUTCDate()).slice(-2)+"_"+("0"+d.getUTCHours()).slice(-2)+("0"+d.getUTCMinutes()).slice(-2)+("0"+d.getUTCSeconds()).slice(-2);
        csvContentLocal = "data:text/csv;charset=utf-8," + csvContentLocal;
        const fileNameLocal = getExperimentId() + '_' + timeSaved + '_recovered.csv';
        var encodedUriLocal = encodeURI(csvContentLocal);
        if(isIE){
            encodedUriLocal = window.location.href.replace('recover', 'results/'+fileNameLocal);
        }
        var link = document.createElement("a");
        document.body.appendChild(link);
        link.setAttribute("type", "hidden");
        link.setAttribute("id", "downloadlink");
        link.setAttribute("href", encodedUriLocal);
        link.setAttribute("download", fileNameLocal);
        link.click();
        alert('Data recovered and downloading');
    }
    else{
        alert('No data could be recovered');
    }
}

function uploadStoredDataRemote() {
    const csvContentServer = restoreStoredData();
    if(csvContentServer){
        const randomCode = randomString(16, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
        var d = new Date();
        var timeSaved = d.getUTCFullYear().toString().slice(-2)+("0"+(d.getUTCMonth()+1)).slice(-2)+("0"+d.getUTCDate()).slice(-2)+"_"+("0"+d.getUTCHours()).slice(-2)+("0"+d.getUTCMinutes()).slice(-2)+("0"+d.getUTCSeconds()).slice(-2);
        const dataString =
        {
            fileNameSubmit: getExperimentId() + '_' + timeSaved + "_recovered.csv",
            dataSubmit: csvContentServer,
            randomCode: randomCode
        };

        $.ajax({
        type: "POST",
        url: "serverSave2.php" + window.location.search, //relative to current route user_id/project_id/
        data: dataString,
        success: function() {
        clearStoredData();
    }});
  }
}

function storedDataExists() {
    const experimentId = getExperimentId();
    const trialsStored = JSON.parse(localStorage.getItem(experimentId+'-'+'trials')) || [];
    if(!trialsStored.length){
        return false;
    }
    return true;
}